import useUser from 'stores/useCustomer';

export function useCustomerConsultant() {
    const consultant_personal_webshop_slug = useUser((store) => store.user?.consultant_personal_webshop_slug);

    return { slug: consultant_personal_webshop_slug };
}
